import React, { SetStateAction, useEffect } from "react";
import { cores } from "./valores_estaticos";

interface ListaFiltroConfig {
    lista_original: any[];
    set_lista_filtrada: React.Dispatch<SetStateAction<any[]>>;
    campoData: string;
}

interface FilterByDataProps {
    listas: ListaFiltroConfig[];
    storageKey?: string;
}

export const FilterByData: React.FC<FilterByDataProps> = ({
    listas,
}) => {
    let aux_listas_originais: any[][] = []

    const dataInicioKey = `filter_by_data_data_inicio`;
    const dataFimKey = `filter_by_data_data_fim`;

    const [dataInicio, setDataInicio] = React.useState(() => {
        return localStorage.getItem(dataInicioKey) || "";
    });

    const [dataFim, setDataFim] = React.useState(() => {
        return localStorage.getItem(dataFimKey) || "";
    });

    const filtrarLista = (
        lista_original: any[],
        campoData: string
    ) => {
        return (lista_original ?? []).filter((item) => {
            const valorData = item[campoData];

            if (!valorData) return false;

            const dataItem = new Date(valorData);

            if (isNaN(dataItem.getTime())) return false;

            const inicio = dataInicio ? new Date(dataInicio) : null;
            const fim = dataFim ? new Date(dataFim) : null;

            if (inicio && dataItem < inicio) return false;

            if (fim) {
                fim.setHours(23, 59, 59, 999);

                if (dataItem > fim) return false;
            }

            return true;
        });
    };

    const onFiltrar = () => {
        listas.forEach((config) => {
            const resultado = filtrarLista(
                config.lista_original,
                config.campoData
            );

            config.set_lista_filtrada(resultado);
        });
    };

    const onLimpar = () => {
        setDataInicio("");
        setDataFim("");

        localStorage.removeItem(dataInicioKey);
        localStorage.removeItem(dataFimKey);

        listas.forEach((config) => {
            config.set_lista_filtrada(config.lista_original ?? []);
        });
    };
    const listasOriginaisKey = React.useMemo(() => {
        return listas
            .map((config) => `${config.lista_original.length}-${config.campoData}`)
            .join("|");
    }, [listas]);
    
    useEffect(() => {
        if (dataInicio || dataFim) {
            onFiltrar();
        }
    }, [listasOriginaisKey]);


    // useEffect(() => {
    //     aux_listas_originais = listas.map((item) => item.lista_original);

    // }, [listas]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 16,
                backgroundColor: "#ffffff",
                padding: "14px 16px",
                borderRadius: 5,
                marginBottom: 16,
                marginLeft: 15,
                flexWrap: "wrap",
                border: "1px solid #e0e0e0",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    flexWrap: "wrap",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label
                        style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#555",
                        }}
                    >
                        Data início
                    </label>

                    <input
                        type="date"
                        value={dataInicio}
                        onChange={(e) => {
                            setDataInicio(e.target.value);
                            localStorage.setItem(dataInicioKey, e.target.value);
                        }}
                        style={{
                            height: 36,
                            padding: "0 10px",
                            border: "1px solid #d0d0d0",
                            borderRadius: 8,
                            fontSize: 14,
                            outline: "none",
                            backgroundColor: "#fafafa",
                            minWidth: 160,
                        }}
                    />
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    <label
                        style={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#555",
                        }}
                    >
                        Data fim
                    </label>

                    <input
                        type="date"
                        value={dataFim}
                        onChange={(e) => {
                            setDataFim(e.target.value);
                            localStorage.setItem(dataFimKey, e.target.value);
                        }}
                        style={{
                            height: 36,
                            padding: "0 10px",
                            border: "1px solid #d0d0d0",
                            borderRadius: 8,
                            fontSize: 14,
                            outline: "none",
                            backgroundColor: "#fafafa",
                            minWidth: 160,
                        }}
                    />
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 20,
                }}
            >
                <button
                    type="button"
                    onClick={onFiltrar}
                    style={{
                        height: 36,
                        padding: "0 16px",
                        border: "none",
                        borderRadius: 8,
                        cursor: "pointer",
                        backgroundColor: cores.cor1,
                        color: "white",
                        fontSize: 14,
                        fontWeight: 600,
                    }}
                >
                    Filtrar
                </button>

                <button
                    type="button"
                    onClick={onLimpar}
                    style={{
                        height: 36,
                        padding: "0 16px",
                        border: "1px solid #d0d0d0",
                        borderRadius: 8,
                        cursor: "pointer",
                        backgroundColor: "#ffffff",
                        color: "#444",
                        fontSize: 14,
                        fontWeight: 600,
                    }}
                >
                    Limpar
                </button>
            </div>
        </div>
    );
};